import api from './api';

export const seoApi = {
  get: () => api.get('/seo', { skipAuth: true }),
  update: (payload) => api.put('/seo', payload),
  tools: () => api.get('/seo/tools'),
};

export default seoApi;
